const LOOKBEHIND_PATTERN = '(?<=a)b'

/**
 * Verifica se o navegador suporta lookbehind em expressões regulares.
 */
export function supportsRegexLookbehind(): boolean {
  try {
    return new RegExp(LOOKBEHIND_PATTERN).test('ab')
  } catch {
    return false
  }
}
